module.exports = __webpack_public_path__ + "img/loveplay_upload.ca62d1f9.jpg";